import React from 'react';
import PropTypes from 'prop-types';
import SvgIconMetroPe from 'components/Svg/iconmetrope';
import SvgIconMetroPeOn from 'components/Svg/iconmetropeon';
import SvgIconMascotas from 'components/Svg/iconmascotas';
import SvgIconMascotasOn from 'components/Svg/iconmascotason';
import SvgIconOtros from 'components/Svg/iconotros';
import SvgIconOtrosOn from 'components/Svg/iconotroson';
import SvgIconVestimenta from 'components/Svg/iconvestimenta';
import SvgIconVestimentaOn from 'components/Svg/iconvestimentaon';
import SvgIconBazar from 'components/Svg/iconbazar';
import SvgIconBazarOn from 'components/Svg/iconbazaron';
import SvgIconBebesNiniosJugueteria from 'components/Svg/iconbebesniniosjugueteria';
import SvgIconBebesNiniosJugueteriaOn from 'components/Svg/iconbebesniniosjugueteriaon';
import SvgIconTecnologiaElectrohogar from 'components/Svg/icontecnologiaelectrohogar';
import SvgIconTecnologiaElectrohogarOn from 'components/Svg/icontecnologiaelectrohogaron';
import SvgIconCuidadoHogar from 'components/Svg/iconcuidadohogar';
import SvgIconCuidadoHogarOn from 'components/Svg/iconcuidadohogaron';
import SvgIconCuidadoPersonal from 'components/Svg/iconcuidadopersonal';
import SvgIconCuidadoPersonalOn from 'components/Svg/iconcuidadopersonalon';
import SvgIconBebidas from 'components/Svg/iconbebidas';
import SvgIconBebidasOn from 'components/Svg/iconbebidason';
import SvgIconAlimentos from 'components/Svg/iconalimentos';
import SvgIconAlimentosOn from 'components/Svg/iconalimentoson';
import SvgIconTodos from 'components/Svg/icontodos';
import SvgIconTodosOn from 'components/Svg/icontodoson';
import SvgIconDiaMadre from 'components/Svg/icondiamadre';
import SvgIconDiaMadreOn from 'components/Svg/icondiamadreon';
import SvgIconAlmacenesOn from 'components/Svg/iconalmaceneson';
import SvgIconAlmacenes from 'components/Svg/iconalmacenes';
import ActionsWebFactory from 'factories/ActionsWeb';


const CategorySliderItem = ({ category = {}, currentPath = '' }) => {

    const actionsEcommerce=()=>{
       
       
        ActionsWebFactory.initialize(); //create localstorage obj actions
        ActionsWebFactory.setItemActionsWeb('categoryclick',true); //set value click ecommerce
        
    }
    

    return (
        <div className="slide">
            <p className="icon">
                <a href={category.path} onClick={actionsEcommerce}>
                    {
                        {
                            'alimentos': (currentPath===category.handle?<SvgIconAlimentosOn />:<SvgIconAlimentos />), 
                            'bazar': (currentPath===category.handle?<SvgIconBazarOn />:<SvgIconBazar />), 
                            'beb-s-ni-os-y-jugueter-a': (currentPath===category.handle?<SvgIconBebesNiniosJugueteriaOn />:<SvgIconBebesNiniosJugueteria />), 
                            'bebidas': (currentPath===category.handle?<SvgIconBebidasOn />:<SvgIconBebidas />), 
                            'cuidado-del-hogar': (currentPath===category.handle?<SvgIconCuidadoHogarOn />:<SvgIconCuidadoHogar />), 
                            'cuidado-personal': (currentPath===category.handle?<SvgIconCuidadoPersonalOn />:<SvgIconCuidadoPersonal />), 
                            'dia-madre': (currentPath===category.handle?<SvgIconDiaMadreOn />:<SvgIconDiaMadre />),
                            'mascotas': (currentPath===category.handle?<SvgIconMascotasOn />:<SvgIconMascotas />), 
                            'otros': (currentPath===category.handle?<SvgIconOtrosOn />:<SvgIconOtros />), 
                            'vestimenta': (currentPath===category.handle?<SvgIconVestimentaOn />:<SvgIconVestimenta />), 
                            'tecnolog-a-y-electrohogar': (currentPath===category.handle?<SvgIconTecnologiaElectrohogarOn />:<SvgIconTecnologiaElectrohogar />), 
                            'todos': (currentPath===category.handle?<SvgIconTodosOn />:<SvgIconTodos />), 
                            'ecommerce': (currentPath===category.handle?<SvgIconMetroPeOn />:<SvgIconMetroPe />),
                            'almacenes':(currentPath==category.handle?<SvgIconAlmacenesOn />:<SvgIconAlmacenes />)
                        }[category.handle]
                    }

                </a>
            </p>
        
            <p className="title" >
            
                <a href={category.path} onClick={actionsEcommerce}>{category.title}</a>
                                   
               
            </p>
           
           
        </div>
    );
}

CategorySliderItem.propTypes = {
    category: PropTypes.object, 
    currentPath: PropTypes.string
};

export default CategorySliderItem;